const FALLBACK = "/account"

/** Accept only same-app absolute paths; reject protocol-relative and control characters. */
export const safeReturnTo = (value: string | null | undefined, fallback = FALLBACK): string => {
  const hasUnsafeCharacter = value ? [...value].some((character) => character.charCodeAt(0) < 32) || value.includes("\\") : false
  if (!value || !value.startsWith("/") || value.startsWith("//") || hasUnsafeCharacter) {
    return fallback
  }
  try {
    const parsed = new URL(value, "https://nbr.invalid")
    return parsed.origin === "https://nbr.invalid" ? `${parsed.pathname}${parsed.search}${parsed.hash}` : fallback
  } catch {
    return fallback
  }
}

export const loginPath = (returnTo?: string) => {
  const target = safeReturnTo(returnTo, "")
  return target ? `/login?returnTo=${encodeURIComponent(target)}` : "/login"
}
